import { StatsigBypass } from '@portal/shared/utils/statsig/types';
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies';

export const BYPASS_KEY = 'bypass';

/**
 * Normalizes and creates a StatsigBypass object for use in bypassing gates
 *
 * @param bypassCookie The bypass cookie
 * @param bypassArray The bypass [key, value] entry
 * @returns A StatsigBypass object if available
 */
export function normalizeBypassData({
  bypassCookie,
  bypassArray
}: {
  bypassCookie?: RequestCookie | undefined;
  bypassArray?: [string, string] | undefined;
}): StatsigBypass | null {
  const bypass = { key: '', group: '' };
  if (bypassCookie) {
    bypass.key = bypassCookie.name;
    bypass.group = bypassCookie.value;
  }
  if (bypassArray) {
    const [key, group] = bypassArray;
    bypass.key = key;
    bypass.group = group;
  }
  return bypass.key && bypass.group ? bypass : null;
}

/**
 * Normalizes the bypass value to prevent multiple custom Statsig fields from filling up
 *
 * @param bypass The StatsigBypass object
 * @returns A formatted bypass string to use in Statsig rules
 */
export function createBypassString(bypass: StatsigBypass | null): string | null {
  if (!bypass) return null;
  return `${bypass.key}=${bypass.group}`;
}
